module.exports = __webpack_public_path__ + "img/vessel_ping.b248d3e0.svg";